export default {
  settings: {
    endpointsSectionTitle: 'Koncové body služby (URI nebo úplná adresa URL)',
    language: 'Jazyk',
    appLocale: 'Lokalizace aplikace',
    unit: 'Jednotka',
    areaUnit: 'Jednotka plochy',
    saveToLocalStorage: 'Uložit v mém prohlížeči',
    routeInstructions: 'Instrukce pro navigaci',
    randomizedIsochroneColors: 'Náhodné izochronní barvy',
    distanceMarkers: 'Značky vzdálenosti',
    elevationProfile: 'Profil převýšení',
    mapSettings: 'Zobrazení mapy a další informace',
    defaultMapSettingsRestored: 'Výchozí nastavení mapy obnoveno a uloženo',
    endpointsTitle: {
      directions: 'Instrukce',
      isochrones: 'Izochrony',
      geocodeSearch: 'Hledání podle Geocode',
      autocomplete: 'Automatické dokončení Geocode',
      pois: 'Body zájmu',
      reverseGeocode: 'Reverzní Geocode'
    },
    apiKey: 'klíč API',
    customApiKey: 'Vlastní klíč API',
    apiBaseUrl: 'Základní URL API',
    invalidSettingsValue: 'Neplatná(é) hodnota(y) nastavení. Zkontrolujte pole nebo obnovte výchozí hodnotu(y)',
    restoreDefaults: 'Obnovit výchozí nastavení',
    advanced: 'Pokročilé',
    mapSettingsSaved: 'Nastavení mapy uloženo',
    alwaysFitBounds: 'Při změně trasy se vždy přizpůsobte hranicím',
    routeExtraInfo: 'Další informace o trase',
    mapViewOptions: 'Možnosti zobrazení mapy',
    advancedSettingsWarning: 'Pokud nevíte, co děláte, neměňte níže uvedená nastavení!',
    customOverlayerTileProviderUrl: 'Vlastní URL poskytovatele překryvné vrstvy',
    customTileProviderUrl: 'Vlastní URL poskytovatele dlaždic',
    defaultTilesProvider: 'Výchozí poskytovatel dlaždic',
    customTileProviderUrlHint: 'https://domain.tld/path/{z}/{x}/{y}.ext?optionalKey=value',
    prioritizeSearchingForNearbyPlaces: 'Upřednostnit vyhledávání míst v okolí',
    defaultProfile: 'Výchozí profil',
    compressDataUrlSegment: 'Komprese segmentu URL po /data/',
    autoFitHighlightedBounds: 'Automatické přizpůsobení zvýrazněných hranic',
    reloadToApplyLanguageChangeTitl: 'Je nutné aplikaci znovu načíst',
    reloadToApplyLanguageChangeText: 'Pro úplné uplatnění změny jazyka je nutné aplikaci znovu načíst. Znovu načíst nyní?',
    resetShownOnceTooltips: 'Zobrazit popisky nástrojů při novém načtení aplikace',
    convertStopAfterRouteEndingToDestination: 'Převést zastávku přidanou na konci trasy na cíl trasy',
    skipAllSegments: 'přímá trasa pro všechny úseky',
    useStopOptimization: 'Optimalizace trasy při vytvoření zastávky přetažením.'
  }
}
